import styled from 'styled-components';

export const FormListContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
`;

export const FormFieldsContainer = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
  flex-wrap: wrap;
`;

export const DeleteContainer = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
  .remove-salary-icon {
    height: 22px;
    width: 22px;
    margin-top: 4px;
    cursor: pointer;
  }
`;

export const MainWrapper = styled.div`
  & > div:last-child {
    flex-wrap: wrap;
  }
`;
